import { render } from "./EmployeeDetail.vue?vue&type=template&id=210ccc96&scoped=true"
import script from "./EmployeeDetail.vue?vue&type=script&lang=js"
export * from "./EmployeeDetail.vue?vue&type=script&lang=js"

import "./EmployeeDetail.vue?vue&type=style&index=0&id=210ccc96&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src4026252432/src/luca_web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-210ccc96"]])

export default __exports__